import React, {memo} from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {showAlert} from '@/actions/setupActions';
import AlertMessage from '@/components/alert/AlertMessage';
import {getMainAlertMessage} from '@/selectors/setupSelector';

function MainAlertMessage() {
  const dispatch = useDispatch();
  const {alertShow, alertText, alertStyle} = useSelector(getMainAlertMessage);

  const onClick = () => {
    dispatch(showAlert({alertShow: false}));
  };

  return (
    <AlertMessage
      alertShow={alertShow}
      alertText={alertText}
      alertStyle={alertStyle}
      onClick={onClick}
    />
  );
}

export default memo(MainAlertMessage);
